import { useState, useEffect } from "react";
import { RefreshCw, X, Trash2 } from "lucide-react";
import { activateWaitingServiceWorker, isIOS } from "../utils/pwaUtils";

function UpdatePrompt({ registration, onClose }) {
  const [isUpdating, setIsUpdating] = useState(false);
  const [isiOSDevice, setIsIOSDevice] = useState(false);

  useEffect(() => {
    setIsIOSDevice(isIOS());
  }, []);

  if (!registration) {
    return null;
  }

  const handleUpdate = () => {
    setIsUpdating(true);
    // Close the prompt immediately
    if (onClose) {
      onClose();
    }
    
    // Add a small delay to allow visual feedback
    setTimeout(() => {
      if (isiOSDevice) {
        // On iOS, just reload the page
        window.location.reload();
      } else {
        activateWaitingServiceWorker(registration);
      }
    }, 500);
  };

  return (
    <div className="fixed bottom-24 left-4 right-4 z-50 animate-slide-up">
      <div className="bg-gradient-to-r from-blue-600 to-cyan-600 rounded-3xl p-5 shadow-2xl">
        {!isUpdating && (
          <button
            onClick={onClose}
            className="absolute top-3 right-3 p-1.5 bg-white/20 hover:bg-white/30 rounded-full transition-all"
          >
            <X className="w-4 h-4 text-white" />
          </button>
        )}

        <div className="flex items-start gap-4">
          <div className="w-12 h-12 bg-white rounded-2xl flex items-center justify-center shadow-lg flex-shrink-0">
            <RefreshCw
              className={`w-6 h-6 text-blue-600 ${
                isUpdating ? "animate-spin" : ""
              }`}
            />
          </div>

          <div className="flex-1">
            <h3 className="text-white font-bold text-lg mb-1">
              {isUpdating ? "Updating..." : "Update Available"}
            </h3>
            {isiOSDevice ? (
              <>
                <p className="text-white/90 text-sm mb-3">
                  A new version is available. On iOS, you may need to:
                </p>
                <ol className="text-white/90 text-sm space-y-2 mb-4 list-decimal list-inside">
                  <li>Remove the app from Home Screen</li>
                  <li>Reinstall it from Safari</li>
                </ol>
              </>
            ) : (
              <p className="text-white/90 text-sm mb-4">
                {isUpdating
                  ? "Please wait while we update the app"
                  : "A new version of the app is available. Update now for the latest features and fixes."}
              </p>
            )}

            {!isUpdating && (
              <button
                onClick={handleUpdate}
                className="w-full py-3 bg-white text-blue-600 rounded-2xl font-semibold shadow-lg hover:shadow-xl transition-all active:scale-95"
              >
                {isiOSDevice ? "Reload App" : "Update Now"}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdatePrompt;
